import i18n from "i18next";

import { Languages } from "@/constants/languages";
import { Routes as AppRoutes } from "@/constants/routes";

export const getLanguage = () => {
    let lng = i18n.language;

    if (typeof window !== "undefined" && window.location) {
        const isOfferUrl = window.location.pathname.includes(
            `/${AppRoutes.Both}/${AppRoutes.Offer}`
        );
        const isFunnelFoxUrl = window.location.pathname.includes(AppRoutes.FFPaywall);
        const isAgeWorkoutWithoutAIUrl = window.location.pathname.includes(
            AppRoutes.AgeWorkoutWithoutAI
        );
        const isBodyScanUrl = window.location.pathname.includes(AppRoutes.BodyScan);
        const isBodyScanAbsUrl = window.location.pathname.includes(AppRoutes.BodyScanAbs);
        const isBodyScanPlanUrl = window.location.pathname.includes(AppRoutes.BodyScanPlans);
        const isBodyScanPlanApplovinUrl = window.location.pathname.includes(
            AppRoutes.BodyScanPlansApplovin
        );
        const isSeniorsUrl = window.location.pathname.includes(AppRoutes.Seniors);
        const isSeniorsApplovinUrl = window.location.pathname.includes(AppRoutes.SeniorsApplovin);
        const isWeightLossUrl = window.location.pathname.includes(AppRoutes.WeightLoss);
        const isPromoCodeUrl = window.location.pathname.includes(AppRoutes.RedeemCode);

        if (
            isOfferUrl ||
            isFunnelFoxUrl ||
            isAgeWorkoutWithoutAIUrl ||
            isBodyScanUrl ||
            isBodyScanAbsUrl ||
            isBodyScanPlanUrl ||
            isBodyScanPlanApplovinUrl ||
            isSeniorsUrl ||
            isSeniorsApplovinUrl ||
            isWeightLossUrl ||
            isPromoCodeUrl
        ) {
            lng = Languages.English;
        }
    } else {
        lng = Languages.English;
    }

    return lng;
};
